import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * FormPageLayout
 * Classification: custom (template)
 *
 * Centered single-column form page with a header and a sticky footer action
 * bar (submit / cancel).
 */
export interface FormPageLayoutProps {
  title: string;
  description?: string;
  children: ReactNode;
  /** Footer actions (submit / cancel). */
  actions?: ReactNode;
  maxWidth?: number;
}

export function FormPageLayout({
  title,
  description,
  children,
  actions,
  maxWidth = 640,
}: FormPageLayoutProps) {
  return (
    <Box sx={{ maxWidth, mx: 'auto', display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box>
        <Typography variant="h4" sx={{ fontFamily: 'inherit' }}>
          {title}
        </Typography>
        {description ? (
          <Typography variant="body1" color="text.secondary" sx={{ mt: 0.5 }}>
            {description}
          </Typography>
        ) : null}
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>{children}</Box>
      {actions ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 1,
            pt: 2,
            borderTop: 1,
            borderColor: 'divider',
          }}
        >
          {actions}
        </Box>
      ) : null}
    </Box>
  );
}
